<template>
    <v-dialog v-model="display" :width="dialogWidth" content-class="mx-auto">
        <template #activator="{ on }">
            <v-text-field
                :disabled="disabled"
                :label="label"
                :loading="loading"
                rounded
                :value="formattedDatetime"
                readonly
                v-bind="textFieldProps"
                v-on="on"
            >
                <template #progress>
                    <slot name="progress">
                        <v-progress-linear absolute color="primary" height="2" indeterminate></v-progress-linear>
                    </slot>
                </template>
            </v-text-field>
        </template>

        <v-card class="timetable-date_picker" elevation="0" flat>
            <v-card-text class="px-0 py-0">
                <v-tabs v-model="activeTab" fixed-widths>
                    <v-tab key="calendar">
                        <slot name="dateIcon">
                            <v-icon>mdi-calendar-month</v-icon>
                        </slot>
                    </v-tab>
                    <v-tab key="timer" :disabled="dateSelected">
                        <slot name="timeIcon">
                            <v-icon>mdi-calendar-clock</v-icon>
                        </slot>
                    </v-tab>
                    <v-tab-item key="calendar">
                        <v-date-picker
                            v-model="date"
                            full-width
                            v-bind="datePickerProps"
                            @input="showTimePicker"
                        ></v-date-picker>
                    </v-tab-item>
                    <v-tab-item key="timer">
                        <!-- <v-time-picker
                          ref="timer"
                          class="v-time-picker-custom"
                          v-model="time"
                          v-bind="timePickerProps"
                          full-width
                        ></v-time-picker> -->
                        <div class="time-wrapper p-4 pb-0">
                            <v-text-field
                                ref="timer"
                                v-model="time"
                                :label="t('default::label.time')"
                                dense
                                outlined
                                required
                                type="time"
                            ></v-text-field>
                        </div>
                    </v-tab-item>
                </v-tabs>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <slot :parent="this" name="actions">
                    <b-dialog-actions close save style="background: inherit" @save="okHandler">
                        <template #left>
                            <v-btn color="default" small @click="clearHandler">
                                <v-icon left small>mdi-close</v-icon>
                                {{ t('default::button.clear') }}
                            </v-btn>
                        </template>
                    </b-dialog-actions>
                </slot>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
const DEFAULT_DATE = '';
const DEFAULT_TIME = '00:00:00';
const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD';
const DEFAULT_TIME_FORMAT = 'HH:mm:ss';
const DEFAULT_DIALOG_WIDTH = 366;

export default {
    model: {
        prop: 'datetime',
        event: 'input',
    },
    props: {
        datetime: {
            type: [Date, String],
            default: null,
        },
        disabled: {
            type: Boolean,
        },
        loading: {
            type: Boolean,
        },
        label: {
            type: String,
            default: '',
        },
        dialogWidth: {
            type: Number,
            default: DEFAULT_DIALOG_WIDTH,
        },
        dateFormat: {
            type: String,
            default: DEFAULT_DATE_FORMAT,
        },
        timeFormat: {
            type: String,
            default: 'HH:mm',
        },
        clearText: {
            type: String,
            default: () => {
                return t('datepicker::label.clear');
            },
        },
        okText: {
            type: String,
            default: () => {
                return t('datepicker::label.ok');
            },
        },
        textFieldProps: {
            type: Object,
            default: () => {
                return {};
            },
        },
        datePickerProps: {
            type: Object,
            default: () => {
                return {};
            },
        },
        timePickerProps: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    data() {
        return {
            display: false,
            activeTab: 0,
            date: DEFAULT_DATE,
            time: DEFAULT_TIME,
        };
    },
    computed: {
        dateTimeFormat() {
            return this.dateFormat + ' ' + this.timeFormat;
        },
        defaultDateTimeFormat() {
            return DEFAULT_DATE_FORMAT + ' ' + DEFAULT_TIME_FORMAT;
        },
        formattedDatetime() {
            if (_.isNull(this.selectedDatetime) || _.isUndefined(this.selectedDatetime)) {
                return '';
            }
            return this.selectedDatetime.format(this.dateTimeFormat);
        },
        selectedDatetime() {
            if (this.date && this.time) {
                let datetimeString = this.date + ' ' + this.time;
                if (this.time.length === 5) {
                    datetimeString += ':00';
                }
                return moment(datetimeString, this.defaultDateTimeFormat);
                // return parse(datetimeString, this.defaultDateTimeFormat, new Date())
            } else {
                return null;
            }
        },
        dateSelected() {
            return !this.date;
        },
    },
    watch: {
        datetime: function () {
            this.init();
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            if (!this.datetime) {
                return;
            }

            let initDateTime;
            if (this.datetime instanceof Date) {
                initDateTime = this.datetime;
            } else if (typeof this.datetime === 'string' || this.datetime instanceof String) {
                // see https://stackoverflow.com/a/9436948
                initDateTime = moment(this.datetime, this.dateTimeFormat);
                this.showTimePicker();
                // initDateTime = parse(this.datetime, this.dateTimeFormat, new Date())
            } else {
                return;
            }

            this.date = initDateTime.format(DEFAULT_DATE_FORMAT);
            this.time = initDateTime.format(DEFAULT_TIME_FORMAT);
        },
        okHandler() {
            this.resetPicker();
            this.$emit('input', this.selectedDatetime);
        },
        clearHandler() {
            this.resetPicker();
            this.date = DEFAULT_DATE;
            this.time = DEFAULT_TIME;
            this.$emit('input', null);
        },
        resetPicker() {
            this.display = false;
            this.activeTab = 0;
            if (this.$refs.timer) {
                this.$refs.timer.selectingHour = true;
            }
        },
        showTimePicker() {
            this.activeTab = 1;
        },
    },
};
</script>

<style scoped>
.v-picker.v-card::v-deep {
    box-shadow: none;
}

.v-card:not(.v-sheet--tile):not(.v-card--shaped)::v-deep {
    border-radius: 0;
}
</style>
